import { render, staticRenderFns } from "./ProductCsrLogo.vue?vue&type=template&id=e9b80c50&scoped=true&"
import script from "./ProductCsrLogo.vue?vue&type=script&lang=ts&"
export * from "./ProductCsrLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b80c50",
  null
  
)

export default component.exports